<template>
  <div class="seedTrace">
    <el-container style="height: 100%;min-height:100vh;" direction="vertical">
      <el-header >
        <span style="font-size: 24px;">农资（种子、肥料、农药等）防伪溯源解决方案</span>
      </el-header>
      <el-main>
        <el-row>
          <span style="font-size: 20px;">1.应用场景</span>
          <p>农资防伪溯源主要应用于农作物种子育、繁、推、销于一体化场景以及肥料和农药的生产加工、销售全产业链条。如下图所示</p>
        </el-row>
        <el-row>
          <img width="600px" height="400px" src="@/assets/image/farm_monitor.png">
        </el-row>
        <el-row>
          <img width="600px" height="380px" src="@/assets/image/trace_monitor.png">
        </el-row>
        <el-row>
          <span style="font-size: 20px;">2.业务功能</span>
        </el-row>
        <el-row>
          <img width="700px" height="400px" src="@/assets/image/seed_trace_module.png">
        </el-row>
        <el-row>
          <span style="font-size: 20px;">3.应用价值</span>
        </el-row>
        <el-row>
          <img width="700px" height="400px" src="@/assets/image/seed_trace_value.png">
        </el-row>
        <el-row>
          <span style="font-size: 20px;">4.在线溯源</span>
        </el-row>
        <el-row>
          <img width="600px" height="330px" src="@/assets/image/farm_trace.png">
        </el-row>
      </el-main>
    </el-container>
  </div>
</template>

<script>
export default {
  name: 'seedTracePage'
}
</script>

<style lang="less" scoped>
body {
  margin: 0px;
}
.seedTrace {
  margin: 0px;
  padding: 0px;
}
.el-row {
  margin-top: 10px;
  padding-top: 10px;
}
</style>
